// AUTO-GENERATED by Phase 5A from validated Phase 3 artifacts.
// Do not edit manually; hashes are verified by the installer/validator.
import type { NatureR03GeneratedAssetManifest } from "./NatureR03RuntimeTypes";

export const NATURE_R03_ASSET_MANIFEST: NatureR03GeneratedAssetManifest = {
  schemaVersion: 1,
  phase: "R0.3_PHASE5A_RUNTIME_REGISTRATION",
  candidateId: "mobilenet_v3_large_imagenet",
  modelBuildId: "mobilenet_v3_large_imagenet",
  modelUrl: "/nature-r03/encoder.tflite",
  modelSha256: "f1a534032af6461fb92f6ec7d16e446225c72a8e51191e856bc68999b2079f60",
  modelBytes: 11943332,
  referenceIndexUrl: "/nature-r03/reference_index_r03.f32",
  referenceIndexSha256: "2989e959c48e078dce5a98aa612223c138f8c9b24baed61a999a3781d30d8e5c",
  referenceIndexBytes: 1036800,
  referenceMetaUrl: "/nature-r03/reference_index_r03.meta.json",
  classSupportUrl: "/nature-r03/class_support.csv",
  resultContractUrl: "/nature-r03/nature_result_contract.json",
  runtimeManifestUrl: "/nature-r03/runtime_manifest.json",
  referenceSpecies: 82,
  referenceObservationGroups: 270,
  embeddingDimension: 960,
  inputSize: 224,
  scoreType: "COSINE_SIMILARITY_NOT_PROBABILITY",
  thresholds: {
    possibleSimilarity: 0.82,
    reviewSimilarity: 0.7,
    minimumMargin: 0.04,
    status: "PROVISIONAL_UNCALIBRATED_WITHOUT_OOD_SET",
  },
};
